import type { FaireProductEntity } from "../../entity_types/product";

export const p_zsxvmkp5yk: FaireProductEntity = {
  token: "p_zsxvmkp5yk",
  type: "product",
  name: "Kit Kat Wafer Strawberry Dark Chocolate 24bags/96g (China)",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl: "https://cdn.faire.com/fastly/e7577757c6d0be551ff26a72984172d1ad01396205b27b632441aeb24e234d5a.jpeg",
  galleryImageUrls: [],
  priceDollars: 133.03,
  description: "Strawberry dark chocolate wafer bites; perfect for premium candy assortments.",
  tags: [],
  msrpDollars: 266.05,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:56.333Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
